/*jshint esversion: 6 */

import global from "../global.js";
import storage from "../storage.js";
import t from '../translate.js';

class Notification {
  default_notify(){
    console.log("OK Notifica" );
    this.onMessageReceived(function(nn){
      setTimeout(function(){
        console.log("MESSAGGIO DI NOTIFICA", nn);
        var s=storage.get();

        try {
          if (typeof s.notifications_received=='undefined') {
            s.notifications_received=[];
          }
          s.notifications_received.push(nn);

          storage.save(s);

          if(global.project.notification_received){
            global.project.notification_received(nn)
          }
          else{
            ;
          }
        }
        catch (e) {
          console.log(e);
        }



        console.log(nn);
      
        if (nn.tap && nn.tap=='background') {
          console.log("NOTIFICA IN BACKGROUND....");
          console.log("HASH",location.hash);
          location.hash=nn.hash;
        }
        else {
          console.log("NOTIFICA IN PRIMO PIANO");

          var icon='<i class="f7-icons">bell</i>';
          if (nn.notification && nn.notification.icon) {
            icon=nn.notification.icon;
          }
          else if (nn.data && nn.data.icon) {
            icon=nn.data.icon;
          }
          else if (nn.icon) {
            icon=nn.icon;
          }

          var title='Poderi';
          if (nn.notification && nn.notification.title) {
            title=nn.notification.title;
          }
          else if (nn.data && nn.data.title) {
            title=nn.data.title;
          }
          else if (nn.title) {
            title=nn.title;
          }

          var body='';
          if (nn.notification && nn.notification.body) {
            body=nn.notification.body;
          }
          else if (nn.data && nn.data.body) {
            body=nn.data.body;
          }
          else if (nn.body) {
            body=nn.body;
          }


          global.app.notification.create({
            icon: icon,
            title: title,
            titleRightText: 'now',
            subtitle: '',
            text: body,
            closeOnClick: true,
            closeTimeout: 3600,
            on: {
              click: function () {
                if (nn.click_action) {
                  document.location.href =nn.click_action;                  
                }
                else {
                  var hash='';
                  if (nn.hash) {
                    hash=nn.hash;
                  }
                  else if (nn.data && nn.data.hash) {
                    hash=nn.data.hash;
                  }
                  else if (nn.notification && nn.notification.hash) {
                    hash=nn.notification.hash;
                  }

                  location.hash=hash;
                }
              }
            }
          }).open();
          
        }
      }, 1000);
    });
  }

  onMessageReceived(notification_function){

    if(global.is_cordova()){
      if( window.FirebasePlugin ) {
        console.log("FIREBASE ESISTENTE");
        window.FirebasePlugin.onMessageReceived(function(notification) {
            console.log(notification);
            notification_function(notification);
          },
          function(error) {
            console.error(error);
        });
      }
      else {
        console.warn("Plugin not available");
      }
    }
    else {
      // debugger
      console.log('global.messaging',global.messaging);
      console.log('firebase.messaging',firebase.messaging);
      if (global.messaging && firebase.messaging.isSupported()){
        global.messaging.onMessage(notification => {
          console.log("Message received. ", notification);
          if (typeof notification=='string') {
            notification=JSON.parse(notification);
          }
          else {
            notification=notification;
          }

          notification_function(notification);
        }, e=>{
          console.log(e);
        });
      }

    }
  }

  getToken(fnc_success, fnc_error) {
    if(global.is_cordova()){
      if( window.FirebasePlugin ) {
        // if(global.iOS()){
        window.FirebasePlugin.grantPermission(function(hasPermission){
          console.log("Permission was " + (hasPermission ? "granted" : "denied"));
        });
        // }
        window.FirebasePlugin.getToken(fnc_success, function(error){
          fnc_error(error);
          console.error(error);
        });
      }
      else {
        fnc_error("Plugin not available");
        console.warn("Plugin not available");
      }
    }
    else {
      // TODO : serve prendere token per inviare notifica.
      // window.Notification invia a tutti i device (browser) che accettano le notifiche
      console.log("Verifico se window.Notification...");
      if( window.Notification ) {
        console.log("entro in window.Notification...");
        window.Notification.requestPermission(function(res){
          // alert("cccc"+res)


          console.log("Res notification:",res);
          if( res == 'denied' ) {
            var s=storage.get();
            s.notification_token=null
            s.notification_token_error='Notifications denied';
            storage.save(s);
            
            fnc_error('Controlla di aver attivato le notifiche per questa app.');
          }
          else {
            console.log("Res non è denied");
 
            console.log("global messaging",global.messaging);
            console.log("firebase.messaging.isSupported",firebase.messaging.isSupported());
            if(!global.messaging){
              console.log('Global.messaging non esiste');
              console.log("Il suo valore è: "+global.messaging);
            }

            if(!firebase.messaging.isSupported()){
              alert('firebase.messaging.isSupported non esiste');
              alert("Il suo valore è: "+firebase.messaging.isSupported);
            }

            if (global.messaging && firebase.messaging.isSupported()){
              console.log(global.messaging);

              global.messaging
              .requestPermission()
              .then(function () {
                console.log("Notification permission granted.");
                console.log("Returning new token:",global.messaging.getToken());
                return global.messaging.getToken();
              })
              .then(function(token) {
                console.log("Notification token ottenuto:",token);
                // alert("Notification token ottenuto: "+token);
                fnc_success(token);
              })
              .catch(function (err) {
                var s=storage.get();
                s.notification_token=null;
                s.notification_token_error=err;
                storage.save(s);

                console.log("Error granting token..");
                fnc_success('0000000-000000-1111-0000');
                console.log("Unable to get permission to notify.", err);
              });
            }

          }
        });
      }
      else {
        console.log(" window.Notification risulta FAlse.. sono nell'else!");

        // fnc_error("This browser does not support system notifications");
        // console.warn("This browser does not support system notifications");
      }
    }
  }

  notifica_home(){
    console.log("OK Notifica" );

    this.getToken(function(token){
      console.log("TOKEN Notifica");
      console.log(token);
      var html='';

      var s=storage.get();
      if (typeof s.notifications_received!='undefined') {
        if (s.notifications_received.length>0) {
          html+='<h3>Pagina delle notifiche</h3>';
          html+='<div class="data-table">';
            html+='<table>';
              html+='<thead>';
                html+='<tr>';
                  html+='<th>'+t('Data')+'</th>';
                  html+='<th>'+t('Messaggio')+'</th>';
                html+='</tr>';
              html+='</thead>';
              html+='<tbody id="farm_list">';
              jQuery.each(s.notifications_received,function(k,v){
                var timestamp=parseInt(v.sent_time);
                if (typeof v['google.sent_time']!='undefined') {
                  timestamp=v['google.sent_time'];
                }
                var d = new Date(timestamp);
                var date=d.getDate() + '/' + (d.getMonth()+1) + '/' + d.getFullYear();
                html+='<tr>';
                  html+='<td>'+date+'</td>';
                  html+='<td>'+v.body+'</td>';
                html+='</tr>';
              });
              html+='</tbody>';
            html+='</table>';
          html+='</div>';
        }
        else {
          html+="<h3>Nessuna notifica trovata.</h3>";
        }
      }
      else {
        html+="<h3>Nessuna notifica trovata.</h3>";
      }

      var content={'title': 'Notifiche', 'content': html};
      global.theme.render(content);

    });

  }
}

export default (new Notification());
